import { Component, Input } from '@angular/core';
import { SettingsTreeNode } from '../igrid-summary-page/igrid-summary-page.component';
import { CommissionService } from '../../services/commission.service';
import { TileComponent } from 'shared';
import { Tree } from 'primeng/tree';
import { PrimeTemplate } from 'primeng/api';

import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-settings-tree',
    templateUrl: './settings-tree.component.html',
    styleUrls: ['./settings-tree.component.scss'],
    imports: [
    TileComponent,
    Tree,
    PrimeTemplate,
    TranslateModule
],
})
export class SettingsTreeComponent {
  @Input() settings: SettingsTreeNode[];

  constructor(private readonly commissionService: CommissionService) {}

  getIcon(action: string): string {
    return this.commissionService.getStatusIcon(action);
  }
}
